import { Card } from "./Card";
import { formatDistanceToNow, parseISO } from "date-fns";

export interface TravelData {
  date: string;
  title: string;
  description: string;
  source: string;
  link: string | null;
  location: string | null;
}

interface TravelAdvisoryProps {
  data: TravelData | null;
  isLoading: boolean;
}

// Format date as relative time (e.g., "2 days ago")
function formatRelativeDate(dateString: string): string {
  try {
    const date = parseISO(dateString);
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.error("Error parsing date:", error);
    return dateString;
  }
}

export function TravelAdvisoryCard({ data, isLoading }: TravelAdvisoryProps) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-4">Travel Advisory</h2>
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <div className="text-gray-400">Loading travel advice...</div>
        </div>
      ) : !data ? (
        <div className="flex justify-center items-center h-full">
          <div className="text-gray-400">No travel advice available.</div>
        </div>
      ) : (
        <div className="space-y-4">
          <div>
            <p className="text-gray-300 font-medium">{data.title}</p>
          </div>

          <p className="text-sm text-gray-400">{data.description}</p>

          <p className="text-xs text-gray-500">
            <span>{formatRelativeDate(data.date)}</span>
            {data.source && (
              <>
                <span className="mx-2 text-gray-600">&nbsp;&nbsp;</span>
                {data.link ? (
                  <a href={data.link} target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 underline">
                    {data.source}
                  </a>
                ) : (
                  <span className="text-xs text-gray-400">{data.source}</span>
                )}
              </>
            )}
          </p>

          <div className="border-t border-gray-700 pt-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center text-white text-xs">
                !
              </div>
              <div>
                <p className="text-sm text-gray-300">{data.location}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}
